export default __webpack_public_path__ + "static/media/recusado.525405c7.svg";